module.exports = "/assets/data/3511bdc316cfe0a12139c5e2d63f1c69-SK3.data.json";